<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  (search)="onSearch()"
  [initData]="true"
  [collapsed]="true"
  [actionMenuVisible]="false"
>
</eo-search-page>

<p-confirmPopup key="surgeryCitizenCancelPopup" [style]="{ width: '700px' }">
</p-confirmPopup>